export default {
  overview: {
    title: "Day submissions",
    subtitle: "Days employees sent from the app, to check and take over as a report.",
    getApp: "Get the Lewara app",
    search: "Search site, sender or text",
    headers: {
      date: "Day",
      project: "Site",
      sender: "Sent by",
      sent_at: "Sent on",
      status: "Status",
      comments: "Comments",
      report: "Report",
    },
    project_named: "named: “{name}”",
    no_project: "No site",
    comment_after_status: "New comment after it was taken over",
    filter: {
      status: "Status",
      all: "All",
    },
  },
  status: {
    OPEN: "Open",
    CONVERTED: "Taken over",
    DISMISSED: "Dismissed",
    INTERRUPTED: "Takeover interrupted",
  },
  detail: {
    title: "Day submission",
    heading: "Day submission of {date}",
    sections: {
      summary: "Overview",
      origin: "Location",
      weather: "Weather",
      entries: "Entries",
    },
    project: "Site",
    changed_meanwhile: "Something has happened to the day submission meanwhile. Reload it before you go on.",
    reload: "Reload",
    read_only: "You may not make reports of this site's day submissions.",
    dismissed: "Dismissed on {date}.",
    dismissed_note: "Dismissed on {date}: {note}",
    converted_cr: "Taken over as [[cr]] no. {number}.",
    merged_cr: "Taken over into [[cr]] no. {number}.",
    converted_hwr: "Taken over as [[hwr]] no. {number}.",
    report_gone: "The report has been deleted since.",
    report_unnamed: "Taken over into a report you may not see.",
    not_found: "This day submission does not exist, or you may not see it.",
    interrupted: "The takeover was interrupted and no report was made. Reopen the day submission to try again.",
    actions: {
      to_cr: "Take over as [[cr]]",
      merge_cr: "Add to [[cr]] no. {number}",
      merge_cr_unnamed: "Add to the day's [[cr]]",
      to_hwr: "Take over as [[hwr]]",
      dismiss: "Dismiss",
      reopen: "Reopen",
      open_report: "Open report",
    },
  },
  section: {
    times: "Working hours",
    crew: "Employees",
    equipment: "Equipment",
    material: "Material",
    additional_effort: "Additional efforts",
    service: "Services",
    work: "Work done",
    occurrence: "Special occurrences",
    note: "Notes to the site management",
    task: "Tasks",
    weather: "Weather",
    other: "Other entries",
  },
  kind: {
    START: "Start of work",
    END: "End of work",
    PAUSE: "Break",
    CREW: "Employee",
    EQUIPMENT: "Machine",
    MATERIAL: "Material",
    ADDITIONAL_EFFORT: "Additional effort",
    SERVICE: "Service",
    WORK: "Work",
    OCCURRENCE: "Occurrence",
    NOTE: "Note",
    TASK: "Task",
    WEATHER: "Weather",
    DATE: "Day",
    PROJECT: "Site",
  },
  entry: {
    named: "“{name}”",
    not_found: "Not found in Lewara",
    record_new: "New",
    record_new_tip: {
      EQUIPMENT: "Created as a new machine when the report is saved, without prices yet",
      MATERIAL: "Created as a new material when the report is saved, without prices yet",
      ADDITIONAL_EFFORT: "Created as a new additional effort when the report is saved, without prices yet",
    },
    record_created: "Created",
    record_created_tip: "Created when the report was saved: open it to add prices and details",
    gone: "deleted",
    unknown: "Entry of a newer app version",
    doubt: "Not confirmed in the app",
    doubt_low: "Recognised with doubt, not confirmed in the app",
    doubt_short: "Unsure",
    automatic: "Filled in automatically",
    automatic_times: "Taken from the time tracking",
    automatic_crew: "Taken from the personnel planning, or added as the sender",
    measured: "Measured at the site",
    none_sections: "No entries: {sections}",
    none_said: {
      START: "Nothing about the start of work, according to the employee",
      END: "Nothing about the end of work, according to the employee",
      PAUSE: "No break, according to the employee",
      CREW: "No other employees, according to the employee",
      EQUIPMENT: "No equipment, according to the employee",
      MATERIAL: "No material, according to the employee",
      ADDITIONAL_EFFORT: "No additional efforts, according to the employee",
      SERVICE: "No services, according to the employee",
      WORK: "No work done, according to the employee",
      OCCURRENCE: "No special occurrences, according to the employee",
      NOTE: "No notes, according to the employee",
      TASK: "No tasks, according to the employee",
      WEATHER: "Nothing about the weather, according to the employee",
      PROJECT: "No site, according to the employee",
    },
    unnamed: "Not mentioned",
    said: "Said: “{text}”",
    people: "With {names}",
    hours: "{hours} h",
    minutes: "{minutes} min",
    device: "Device no. {number}",
    own_time: "own time {from}–{to}",
    span: "{from}–{to}",
    since: "from {from}",
    until: "until {to}",
    to_end: "until the end of the shift",
    since_to_end: "from {from} until the end of the shift",
    reason: "Reason: {reason}",
    assignee: "For {name}",
    due: "due {date}",
    at: {
      START: "Morning",
      MID: "Midday",
      END: "Afternoon",
    },
    at_short: {
      START: "Morning",
      MID: "Midday",
      END: "Afternoon",
    },
  },
  reason: {
    WEATHER: "Weather",
    MATERIAL: "Material missing",
    EQUIPMENT: "Equipment or machine",
    OTHER_TRADES: "Other trades",
    CLIENT: "Client or planning",
    ACCIDENT: "Accident",
    OTHER: "Other",
  },
  dialog: {
    cancel: "Cancel",
  },
  readiness: {
    title: "Takeover",
    cr: "As [[cr]]",
    hwr: "As [[hwr]]",
    for_cr: "{message} ([[cr]] only)",
    for_hwr: "{message} ([[hwr]] only)",
  },
  warning: {
    UNKNOWN_ENTRY_SKIPPED: "Not taken over",
    DUPLICATE_SKIPPED: "Twice, taken over once",
    SUMMED: "Named more than once, amounts are added up",
    CREW_OWN_TIME_NOT_ON_CONSTRUCTION_REPORT: "Own time is not on the [[cr]]",
    FREE_SERVICE: "Not in the service catalogue, becomes a free service",
    NOT_ON_HOURLY_WAGE_REPORT: "Not on the [[hwr]]",
    TASK_NOT_CONVERTED: "Tasks go into no report",
    MERGE_KEEPS_TIMES: "Working time stays as on the [[cr]]",
    MERGE_KEEPS_BREAKS: "Break stays as on the [[cr]]",
    MERGE_KEEPS_WEATHER: "Weather stays as on the [[cr]]",
    WEATHER_TO_COMMENTS: "Goes into the remarks",
    ADDITIONAL_EFFORT_TO_COMMENTS: "Goes into the remarks of the [[cr]]",
    NEW_RECORD: "Created when saved",
    RECORD_BY_NAME: "Already in Lewara, is assigned to it",
    NEW_NAME_UNTRANSLATED: "Not translated, created as it is",
    MERGE_KEEPS_LINE: "Already on the [[cr]], stays as it is there",
    MERGE_INTO_PRINTED: "The [[cr]] is printed, the next print becomes a new revision",
  },
  convert_cr: {
    title: "Take over as [[cr]]",
    title_merge: "Add to [[cr]] no. {number}",
    merge_text:
      "There is [[cr]] no. {number} for {date} already. The day submission adds what it is missing; what is on it stays. Into which shift?",
    shift: "Shift",
    shift_new: "A new shift",
    shift_n: "Shift {n}: {from}–{to}",
  },
  convert_hwr: {
    title: "Take over as [[hwr]]",
  },
  // What is chosen before the editor opens: the site of a day submission naming none
  convert: {
    site_text: "The day submission names no site. Which one is the report for?",
    site: "Site",
    site_nearby: "Near where it was recorded: {sites}.",
    site_distance: "{name} ({meters} m)",
    open: "Open in the editor",
  },
  // Above a report a day submission filled
  report: {
    notice: "From the day submission",
    from_sender: "From {name}'s day submission of {date}",
    from: "From the day submission of {date}",
    gaps: "{count} to complete | {count} to complete",
    hints: "{count} note | {count} notes",
    show: "Show the points",
    hide: "Hide the points",
    made: "Created when saved, without prices yet",
    weather_subject: "Weather ({at})",
    changed: "The day's report has been changed meanwhile. Open the day submission again to add to it as it is now.",
    redraft: "Open again",
  },
  // What a report of the day submission lacks: worded to follow the line, to be completed in the editor
  gap: {
    project_missing: "No site given",
    entry_unlinked: "Not found in Lewara",
    entry_record_missing: "Deleted in Lewara",
    position_record_missing: "Staff role deleted in Lewara",
    new_record_forbidden: "Not in Lewara, and you may not create it",
    crew_position_missing: "Without a staff role",
    device_number_missing: "Without a device no.",
    machine_hours_outside_shift: "Hours do not fit the working time",
    machine_unit_unresolved: "Machine without a billing unit",
    amount_missing: "Without an amount",
    amount_not_integer: "Amount with decimals",
    unit_mismatch: "Said in another unit",
    quantity_missing: "Without a quantity",
    service_not_bookable: "Position cannot be booked",
    times_missing: "Working time incomplete",
    times_missing_start: "Start of work missing",
    times_missing_end: "End of work missing",
    pause_without_times: "Only a length, no times",
    weather_incomplete: "Weather incomplete",
    crew_or_machine_missing: "No employee and no machine",
    nothing_to_report: "No service, work or occurrence",
    nothing_to_book: "No employee, machine, material or additional effort",
    hours_unknown: "Without hours",
    merge_manual_cost_split: "Costs split by hand, the new service's share is missing",
    people_unlinked: "An employee not found in Lewara",
    people_gone: "An employee deleted in Lewara",
    people_position: "An employee without a staff role",
    people_hours: "An employee without hours",
  },
  dismiss: {
    title: "Dismiss day submission",
    text: "No report is made of the day submission. The employee does not see in the app that it was dismissed.",
    note: "Note (internal, optional)",
    confirm: "Dismiss",
  },
  comments: {
    title: "The employee's comments",
    after_status: "after the takeover",
  },
  location: {
    recorded: "Recorded",
    // Only where the place may be more than 100 m off
    vague_m: "Only accurate to about {meters} m",
    vague_km: "Only accurate to about {km} km",
    map: "Map of where it was recorded",
    site: "Site",
    nearby: "Nearby",
    distance_m: "{meters} m away",
    distance_km: "{km} km away",
    chosen: "Chosen",
    none_nearby: "No site with coordinates within 10 km",
    // Without a location: whether the app is still looking (up to 15 minutes after sending), found none or sent none
    location: "Location",
    searching: "Still being determined",
    searching_hint: "The phone found none when sending. The app adds it until {time}.",
    unavailable: "Could not be determined",
    unavailable_hint: "The phone found none in the 15 minutes after sending either.",
    none: "Not sent",
    // A location the phone found only after sending
    after_sending: "Determined after sending",
    after_sending_minutes: "{minutes} min after sending",
    after_sending_soon: "Right after sending",
  },
  weather: {
    recorded: "Measured as it was recorded",
    said: "As the employee said",
    office: "Entered by you",
    missing: "Missing",
    none: "There is no weather for the day.",
  },
  snackbar: {
    converted_cr: "[[Cr]] no. {number} created.",
    merged_cr: "Added to [[cr]] no. {number}.",
    converted_hwr: "[[Hwr]] no. {number} created.",
    dismissed: "Day submission dismissed.",
    reopened: "Day submission reopened.",
  },
}
